const getters = {
    getFilterData: (state) => {
        return state.durationFilter;
    },
    getMeetingChatById: (state) => (chatId) => {
        const chatData = state.agendaMeetingChatLists.filter((chat) => chat.chatid === chatId);

        return chatData ? chatData[0] : {}
    },
};

export default getters;
